// @flow
// @jsx h
import { h, Component } from "preact";
import { Text } from "preact-i18n";
//liste ds pays
import { ThemeConfig } from "elc-theme";

import { PrimaryButton, BackButton } from "elc-button";
import { ConfirmationIcon } from "elc-icons";
import Loading from "elc-loading";

import styles from "./style.scss";

type PaymentAssuranceProps = {
  locale: string,
  dataAssurance: object | null,
  getAssurance: Function,
  initAssuranceMeetch: Object
};

type PaymentAssuranceState = {
      loader: Boolean,
      dataAssurance : Object | null,
      initAssuranceMeetch : Object | null
};


export default class PaymentAssurance extends Component<PaymentAssuranceProps, PaymentAssuranceState> {
  constructor(props) {
    super(props);
    
    this.state = {
      loader: true,
      dataAssurance : null,
      initAssuranceMeetch : null
    };

    if (props.dataAssurance != null) {
      this.setState({dataAssurance : props.dataAssurance});
    }

      this.timeoutId = null;
      
    if (props.initAssuranceMeetch != null) {
      this.setState({initAssuranceMeetch : props.initAssuranceMeetch, loader : false},
        () => {
           this.timeoutId = setTimeout(() => {
              this.onClickAssurancePayment();
            }, 5000); // 3 secondes
        });
    }


  
  }

  onClickAssurancePayment = () => {
    let locale = this.props.locale === "en" ? "uk" : this.props.locale
    let url = this.state.initAssuranceMeetch?.urlTunnel?.[locale] || '#';
    window.open(url, '_blank');
  };

  componentDidMount() {
    // console.log("componentDidMount PaymentAssuranceProps", this.props);
    // console.log(
    //   "componentDidMount PaymentAssuranceProps this.state",
    //   this.state,
    // );

    this.props.getAssurance("json-addock-ajout-assurance");


  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.initAssuranceMeetch !== this.state.initAssuranceMeetch) {
        this.setState({initAssuranceMeetch : nextProps.initAssuranceMeetch, loader : false},
        () => {
           this.timeoutId = setTimeout(() => {
              this.onClickAssurancePayment();
            }, 5000); // 3 secondes
        });
    }

  }


  render({ locale }: PaymentAssuranceProps, {  dataAssurance, initAssuranceMeetch }: PaymentAssuranceState) {
          
    return (
      <ThemeConfig.Consumer>
        {(themeConfig) => {
          return (
            <div class={styles.assuranceWidgetContainer}>
              <div class={styles.content}>
                <div class={styles.assuranceInfos}>
                    <strong><Text id="payment.assurance.infoPartStrong">Votre paiement s'est effectué avec succès</Text></strong>
                    <p>
                      <Text id="payment.assurance.infoPart1">Vous serez rediriger automatiquement sur le site de notre partenaire</Text>
                    </p>
                    <em><Text id="payment.assurance.infoPart3">Si la page ne s'ouvre pas cliquez sur Payer mon assurance</Text></em>
                </div>
              </div>
              <header
                class={styles.headerTitle}
                style={`color:${
                  themeConfig && themeConfig.color1 ? themeConfig.color1 : ""
                };`}
              >
                <h2>
                  <Text id="payment.assurance.title">Payez mon assurance</Text>
                </h2>
              </header>
              {this.state.loader === true ? (
                <div class={styles.content}>
                  <div class={styles.iconContainer}>
                    <Loading />
                  </div>
                  <div class={styles.headerContainer}>
                    <Text id="payment.assurance.prepare">
                      Votre contrat d'assurance est en cours de préparation
                    </Text>
                  </div>
                </div>
              ) : (
                <div class={styles.content}>
                  <div class={styles.iconContainer}>
                     {/*<ConfirmationIcon color={styles.iconColor} />*/}
                  </div> 
                  <div class={styles.headerContainer}>
                    <Text id="payment.assurance.pret">
                      Votre contrat d 'assurance est prêt
                    </Text>
                  </div>
                </div>
              )}

              <div class={styles.footerButton}>
                <PrimaryButton
                  handleClick={this.onClickAssurancePayment}
                  disabled={this.state.loader === true}
                >
                  <Text id="payment.assurance.button">Payer</Text>
                </PrimaryButton>
              </div>
            </div>
          );
        }}
      </ThemeConfig.Consumer>
    );
  }
}
